import { useNavigate } from 'react-router-dom'
import { SidebarMenuItem, SidebarMenuButton } from '@/components/ui/sidebar'
import { useTranslation } from '@/hooks/use-translation'
import { useSetupProgress } from '../hooks/use-setup-progress'
import { SetupProgressRing } from './SetupProgressRing'

export function SetupProgressCollapsed() {
  const t = useTranslation()
  const navigate = useNavigate()
  const { steps, overallPercentage, isFullyComplete, isLoading, isDismissed } = useSetupProgress()

  if (isLoading || isFullyComplete || isDismissed) return null

  const firstIncompleteStep = steps.find((s) => !s.isComplete)

  const handleClick = () => {
    if (firstIncompleteStep) {
      navigate(firstIncompleteStep.to)
    }
  }

  return (
    <div className="flex justify-center py-2">
      <SidebarMenuItem className="list-none">
        <SidebarMenuButton
          onClick={handleClick}
          tooltip={t('setupProgress.percentComplete', { percent: overallPercentage })}
          className="flex items-center justify-center cursor-pointer hover:bg-primary-50 transition-smooth"
        >
          <SetupProgressRing percentage={overallPercentage} size={24} strokeWidth={2.5} showLabel={false} />
        </SidebarMenuButton>
      </SidebarMenuItem>
    </div>
  )
}
